import { render } from "./UserAbsensi.vue?vue&type=template&id=403067c4"
import script from "./UserAbsensi.vue?vue&type=script&lang=js"
export * from "./UserAbsensi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__